import useOnClickOutside from 'hooks/useOnClickOutside';
import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import DeleteWorkflowModal from './DeleteWorkflowModal';
import DuplicateWorkflowModal from './DuplicateWorkflowModal';

const DropdownButton = ({ data }) => {
  const ref = useRef();
  const [isActive, updateIsActive] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [duplicateModalOpen, setDuplicateModalOpen] = useState(false);

  const dispatch = useDispatch();

  useOnClickOutside(ref, () => {
    updateIsActive(false);
  });

  return (
    <>
      <DeleteWorkflowModal
        workflows={[data]}
        open={modalOpen}
        onClose={(e) => setModalOpen(false)}
      />
      <DuplicateWorkflowModal
        id={data.id}
        name={data.name}
        open={duplicateModalOpen}
        onClose={(e) => setDuplicateModalOpen(false)}
      />

      <div className={`dropdown is-right ${isActive ? 'is-active' : ''}`}>
        <div className="dropdown-trigger">
          <button
            aria-haspopup="true"
            aria-controls="dropdown-menu"
            className="button is-small"
            onClick={(e) => {
              updateIsActive(!isActive);
            }}
          >
            <i className="menu fas fa-ellipsis-h"></i>
          </button>
        </div>

        <div
          className="dropdown-menu"
          style={{ width: `150px` }}
          id="dropdown-menu"
          role="menu"
          ref={ref}
        >
          <div className="dropdown-content">
            <Link to={`/workflows/editor/${data.id}`} className="dropdown-item">
              <i className="far fa-edit"></i> Edit
            </Link>
            <a
              href="#"
              onClick={(e) => {
                setDuplicateModalOpen(true);
                updateIsActive(false);
              }}
              className="dropdown-item"
            >
              <i className="far fa-copy"></i> Duplicate
            </a>
            <a
              href="#"
              onClick={(e) => {
                setModalOpen(true);
                updateIsActive(false);
              }}
              className="dropdown-item delete-item"
            >
              <i className="far fa-trash-alt"></i> Delete
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
export default DropdownButton;
